import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysError from "@/features/system-states/sys-error";

export default function NotFoundPage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-04")}>
      <SysError />
    </SystemStatePage>
  );
}
